import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css"
import React  from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Partners from './pages/Partners';
import Privacy from './pages/Privacy';
import Sidebar from "./components/Sidebar";
import { Col, Row } from 'react-bootstrap';


function App() {

  return (
    <BrowserRouter>  
      <div className="main">
        <div className='header'>
            <Row className='align-items-center justify-content-center' style={{"position" : "fixed"}}>
            {/* <div className='col s2 m4 l2'>
              <div className='nav-link'>              
                <Sidebar />
              </div>
            </div> */}
            <Col xs={12} md={4} lg={8} className='col s12 m4 l8'></Col>
            <Col  xs={2} md={4} lg={2} className='col s2 m4 l2'></Col>
            </Row>                
            <Row className='align-items-center justify-content-center'  style={ {"minHeight" : "60vw"}}>
              <Col xs={12} md={8}  lg={6}>
                <div className="brand" style={{textAlign: 'center'}}>
                  <img src="/assets/img/logo-iliens-blanc.png" alt="Iliens" style={ {"maxWidth" : "410px", "width" : "100%", "marginBottom" : "35px" }} />
                  <br/>
                  <h5 style={{fontWeight: 800}}>Îlien.ne.s</h5>
                  <p>Ce mot est né de la contraction de Îlien,<br/> l'habitant d'une île, et alien,<br/> l'étranger à un lieu.</p>
                </div>                
              </Col>
            </Row>
        </div>      
        <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/partenaires" element={<Partners />} /> */}
            <Route path='/mentions-legales' element={<Privacy />} />
        </Routes>
      </div>
    </BrowserRouter>    
  );
}

export default App;
